import React from 'react';
import { Route } from 'react-router-dom';

import Widget from '../../components/widgets/Widget';

class PublicAuthenticationLayer extends React.Component {
    render() {
        return(
            <Route render={() => <Widget isPublic={true} {...this.props} />} />
        )
    }
}

export default PublicAuthenticationLayer;
